import { apiClient } from '@/api/client';
import type { ApiResponse, LicenseStatus } from '@/types/api';

export interface SubscriptionInvoice {
  _id: string;
  planCode: string;
  amountInr: number;
  status: string;
  invoiceNumber?: string | null;
  invoicePdfUrl?: string | null;
  paidAt?: string | null;
  validUntil?: string | null;
  createdAt: string;
}

export interface LicenseOrder {
  orderId: string;
  keyId: string;
  amountPaise: number;
  currency: string;
  plan: { code: string; name: string; priceInr: number; marketing: string };
  months: number;
  houseCount: number;
  amountInr: number;
  subscriptionId: string;
}

export class LicenseService {
  static async status() {
    const { data } = await apiClient.get<ApiResponse<LicenseStatus>>('/license/status');
    return data;
  }

  static async activate(key: string) {
    const { data } = await apiClient.post<ApiResponse<LicenseStatus>>('/license/activate', { key });
    return data;
  }

  static async createOrder(planCode = 'starter', months = 1, kind: 'term' | 'expansion' = 'term') {
    const { data } = await apiClient.post<ApiResponse<LicenseOrder>>('/license/orders', {
      planCode,
      months,
      kind,
    });
    return data;
  }

  static async confirmPayment(payload: {
    razorpayPaymentId: string;
    razorpayOrderId: string;
    razorpaySignature: string;
  }) {
    const { data } = await apiClient.post<ApiResponse<LicenseStatus>>('/license/confirm', payload);
    return data;
  }

  static async listInvoices(params?: { page?: number; limit?: number }) {
    const { data } = await apiClient.get<ApiResponse<SubscriptionInvoice[]>>('/license/invoices', {
      params,
    });
    return data;
  }

  static async invoicePdf(id: string) {
    const { data } = await apiClient.get<Blob>(`/license/invoices/${id}/pdf`, { responseType: 'blob' });
    return data;
  }
}
